import { render, staticRenderFns } from "./CampaignsReports.vue?vue&type=template&id=79509ad6&scoped=true&"
import script from "./CampaignsReports.vue?vue&type=script&lang=js&"
export * from "./CampaignsReports.vue?vue&type=script&lang=js&"
import style0 from "./CampaignsReports.vue?vue&type=style&index=0&id=79509ad6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79509ad6",
  null
  
)

export default component.exports